/* global axios */
import ApiClient from './ApiClient';

class CallRecordsAPI extends ApiClient {
  constructor() {
    super('call_records', { accountScoped: true });
  }

  // GET /api/v1/accounts/:account_id/call_records
  get(params = {}) {
    return axios.get(this.url, { params });
  }

  // GET /api/v1/accounts/:account_id/call_records/:id
  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // GET /api/v1/accounts/:account_id/call_records/stats
  getStats(params = {}) {
    return axios.get(`${this.url}/stats`, { params });
  }

  // GET /api/v1/accounts/:account_id/call_records/contact/:contact_id
  getForContact(contactId) {
    return axios.get(`${this.url}/contact/${contactId}`);
  }

  // GET /api/v1/accounts/:account_id/call_records/conversation/:conversation_id
  getForConversation(conversationId) {
    return axios.get(`${this.url}/conversation/${conversationId}`);
  }

  // GET /api/v1/accounts/:account_id/call_records/download
  download(params = {}) {
    return axios.get(`${this.url}/download`, { params, responseType: 'text' });
  }

  // POST /api/v1/accounts/:account_id/call_records/reconcile
  // Com start_date/end_date o backend reprocessa esse período do CDR (backfill);
  // sem eles, só a janela incremental recente.
  reconcile(params = {}) {
    return axios.post(`${this.url}/reconcile`, params);
  }

  // DELETE /api/v1/accounts/:account_id/call_records/:id
  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new CallRecordsAPI();
